import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { JOB_CATEGORIES, roleToSlug } from '../utils/constants';

const Careers = () => {
  const [expandedCategory, setExpandedCategory] = useState(0);

  const toggleCategory = (index) => {
    setExpandedCategory(expandedCategory === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black text-white pt-24">
      <div className="max-w-5xl mx-auto px-6 py-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Careers</h1>
          <p className="text-white/70 text-xl max-w-2xl mx-auto">
            Join our team of innovators, engineers, and visionaries shaping the future of AI and robotics.
          </p>
        </motion.div>

        {/* Job Categories */}
        <div className="space-y-4">
          {JOB_CATEGORIES.map((category, categoryIndex) => (
            <motion.div
              key={category.category}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: categoryIndex * 0.1 }}
              className="bg-white/5 backdrop-blur-lg rounded-2xl border border-white/10 overflow-hidden"
            >
              {/* Category Header */}
              <button
                onClick={() => toggleCategory(categoryIndex)}
                className="w-full px-8 py-6 flex items-center justify-between hover:bg-white/5 transition-colors"
              >
                <h2 className="text-2xl font-semibold">{category.category}</h2>
                <motion.div
                  animate={{ rotate: expandedCategory === categoryIndex ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <ChevronDown size={24} />
                </motion.div>
              </button>

              {/* Roles List */}
              <AnimatePresence>
                {expandedCategory === categoryIndex && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-8 pb-6 space-y-2">
                      {category.roles.map((role) => (
                        <Link
                          key={role}
                          to={`/jobs/${roleToSlug(role)}`}
                          className="block px-6 py-4 bg-white/5 rounded-xl hover:bg-white/10 transition-colors group"
                        >
                          <div className="flex items-center justify-between">
                            <span className="text-lg">{role}</span>
                            <ChevronRight
                              size={20}
                              className="text-white/40 group-hover:text-white group-hover:translate-x-1 transition-all"
                            />
                          </div>
                        </Link>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Careers;